import initializeComponent from 'Shared/react-initialize';
import { extendTheme } from '@chakra-ui/react';
import ChakraDefaultProvider from 'Shared/chakra-provider';
import { theme } from '@carpenter/theme';
import { ComponentType } from 'react';

export const extendedTheme = extendTheme(theme);

export function Initializer<T extends JSX.IntrinsicAttributes>(Component: ComponentType<T>) {
   return (props: T) => (
      <ChakraDefaultProvider theme={extendedTheme}>
         <Component {...props} />
      </ChakraDefaultProvider>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
